import {
  ChangeDetectorRef,
  Component,
  effect,
  HostListener,
  inject,
  Signal,
} from '@angular/core';
import { LoadingAnimationComponent } from '../../../components/feedback/loading-animation/loading-animation.component';
import { TicketTileComponent } from '../../../components/data-display/ticket-tile/ticket-tile.component';
import { ToTicketTilePipe } from '../../../pipes/to-ticket-tile/to-ticket-tile.pipe';
import { BannerComponent } from '../../../components/data-display/banner/banner.component';
import {
  CONFIGURATION_SETTING_KEYS,
  EEntityType,
  ERelationType,
  ISubscriptionTicket,
} from '@web/dtos';
import { CorporateDesignStore } from '../../../services/api/corporate-design/corporate-design-store.service';
import { OrderSubscriptionSupportService } from '../../../services/support/order-subscription-support/order-subscription-support.service';
import { SubscriptionConfigStore } from '../../../services/api/subscription/subscription-config-store.service';
import { EqualizingService } from '../../../services/support/equalizing-support/equalizing.service';
import { Router } from '@angular/router';
import { ActiveSubscriptionTicketsStore } from '../../../services/api/subscription/active-subscriptions/active-subscriptions-store.service';
import { ConfigurationStore } from '../../../services/api/configuration/configuration-store.service';

@Component({
  selector: 'aw-subscription-tickets-page',
  imports: [
    LoadingAnimationComponent,
    TicketTileComponent,
    ToTicketTilePipe,
    BannerComponent,
  ],
  templateUrl: './subscription-tickets-page.component.html',
})
export class SubscriptionTicketsPageComponent {
  private readonly subscriptionStore: ActiveSubscriptionTicketsStore = inject(
    ActiveSubscriptionTicketsStore
  );
  private readonly subscriptionConfigStore: SubscriptionConfigStore = inject(
    SubscriptionConfigStore
  );
  public readonly corporateDesignStore: CorporateDesignStore =
    inject(CorporateDesignStore);
  public readonly configurationStore: ConfigurationStore =
    inject(ConfigurationStore);
  public readonly orderSubscriptionSupport: OrderSubscriptionSupportService =
    inject(OrderSubscriptionSupportService);
  private readonly equalizingService: EqualizingService =
    inject(EqualizingService);
  private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly router: Router = inject(Router);

  public readonly isLoadingSubscriptions: Signal<boolean> =
    this.subscriptionStore.isLoading;
  public readonly subscriptions: Signal<ISubscriptionTicket[]> =
    this.subscriptionStore.subscriptions;

  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly RelationType: typeof ERelationType = ERelationType;

  @HostListener('window:resize', ['$event'])
  windowResize() {
    this.equalize();
  }

  constructor() {
    effect(() => {
      if (this.subscriptions()) {
        this.equalize();
      }
    });
    effect((): void => {
      if (!this.configurationStore.isLoading()) {
        if (
          !this.configurationStore.getBooleanConfiguration(
            CONFIGURATION_SETTING_KEYS.IsSubscriptionActive
          )
        ) {
          this.router.navigate(['/']);
        }
      }
    });
  }

  configureSubscription($event: string): void {
    const subscriptionTicket: ISubscriptionTicket | undefined =
      this.subscriptionStore
        .subscriptions()
        .find(
          (subscriptionTicket: ISubscriptionTicket): boolean =>
            subscriptionTicket.name === $event
        );
    if (subscriptionTicket) {
      this.subscriptionConfigStore.loadSubscriptionConfiguration(
        subscriptionTicket.name
      );
      this.orderSubscriptionSupport.tryToOrderAboTicket($event);
    }
  }

  protected equalize(): void {
    this.cdRef.detectChanges();
    const toEqual: string[] = [
      'upper-ticket-segment-ticket-tile',
      'lower-ticket-segment-ticket-tile',
    ];
    this.equalizingService.equalize(toEqual);
  }
}
